export interface SuperAdminStatisticsApiResponse {
  apiResult: Record<
    string,
    {
      nbInsurerApmt?: number;
      nbCustomerApmt?: number;
      nbActiveInsurerAccounts?: number;
      nbBrandFitters?: number;
      nbAppointments?: number;
      variationFactor?: number;
      repairRate?: number;
      conversionRate?: number;
    }
  >;
}

export interface SuperAdminCosmosExportApiResponse {
  apiResult: Record<
    string,
    {
      groupBy?: Record<string, number>;
      replacementVehicle?: Record<'true' | 'false', number>;
      outsideIntervention?: Record<'true' | 'false', number>;
      nbModif?: Record<string, number>;
      otherAddress?: Record<'true' | 'false', number>;
    }
  >;
}
